import { render, staticRenderFns } from "./AudioTrivia.vue?vue&type=template&id=4314371c&scoped=true&"
import script from "./AudioTrivia.vue?vue&type=script&lang=js&"
export * from "./AudioTrivia.vue?vue&type=script&lang=js&"
import style0 from "./AudioTrivia.vue?vue&type=style&index=0&id=4314371c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314371c",
  null
  
)

export default component.exports